import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var CheckShield = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.995 6.9a.998.998 0 00-.548-.795l-8-4a1 1 0 00-.895 0l-8 4a1.002 1.002 0 00-.547.795c-.011.107-.961 10.767 8.589 15.014a.987.987 0 00.812 0c9.55-4.247 8.6-14.906 8.589-15.014zM12 19.897C5.231 16.625 4.911 9.642 4.966 7.635L12 4.118l7.029 3.515c.037 1.989-.328 9.018-7.029 12.264z",
    key: "k0"
  }), React.createElement("path", {
    d: "M11 12.586l-2.293-2.293-1.414 1.414L11 15.414l5.707-5.707-1.414-1.414z",
    key: "k1"
  }));
});
CheckShield.displayName = 'CheckShield';
export var CheckShieldDimensions = {
  height: 24,
  width: 24
};